import type { ReactNode } from "react";
import { ProgressBar, vars, type ProgressTone } from "@pack-it-up/ui-web";
import * as styles from "./ProgressCard.css.js";

// A single dual-progress card in the trip header (kit `.progress-card`): glyph label
// left, "n / m packed" fraction right, toned bar (amber packing / blue to-do) below.
// `icon` is display-only; `label` stays the accessible name of the bar.
export const ProgressCard = ({
  icon,
  label,
  unit,
  tone,
  checked,
  required,
  secondary,
}: {
  icon: ReactNode;
  label: string;
  unit: string;
  tone: ProgressTone;
  checked: number;
  required: number;
  // T27: cumulative staged-or-packed count, folded into the packing bar as a second
  // tier rather than a separate card — see ProgressBar's `secondary`.
  secondary?: number;
}): ReactNode => (
  <div style={{ border: `1px solid ${vars.color.border}`, borderRadius: vars.radius.lg, background: vars.color.surface, padding: `${vars.space.md} ${vars.space.lg}` }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: vars.font.sizeXs, fontWeight: vars.font.weightMedium, marginBottom: vars.space.sm }}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: vars.space.xs }}>
        <span aria-hidden style={{ display: "inline-flex" }}>{icon}</span>
        {label}
      </span>
      <span style={{ color: vars.color.textMuted, fontVariantNumeric: "tabular-nums" }}>
        {checked} / {required} <span className={styles.unit}>{unit}</span>
      </span>
    </div>
    <ProgressBar tone={tone} checked={checked} required={required} {...(secondary !== undefined ? { secondary } : {})} showCount={false} label={label} />
  </div>
);
